import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import { AiOutlineSetting, AiOutlineSave, AiFillCloseCircle, AiOutlineFilePdf, } from 'react-icons/ai'
import AppContext from '../context'
import WP_DATA from 'utils/wp_data'
import colors from 'utils/colors'
import Save from 'components/form/save'
import Report from 'components/report'

const MenuBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  & > h1 { margin-right: auto; }
  & button {
    margin-left: 15px;
    padding-left: 20px;
    padding-right: 20px;
  }
`

const Settings = styled.div`
  background: #eee;
  margin-bottom: 25px;
  padding: 15px;
  display: grid;
  grid-gap: 60px;
  grid-template-columns: 1fr 1fr;
  @media(max-width: 767px) {
    display: block;
  }
  h3 {
    font-weight: bold;
  }
`

export default () => {
  const { state, dispatch, save } = useContext(AppContext)
  const [open, setOpen] = useState(false)

  const handleSettingsToggle = () => {
    if (open)
      save()
    setOpen(!open)
  }
  
  return (
    <>
      <MenuBar>
        <h1>{state.title}</h1>
        <button
          onClick={handleSettingsToggle}
          style={{background: colors.darkgrey}}
          type="button" 
        >
          {!open ? <AiOutlineSetting/> : <AiFillCloseCircle/>}
          {' '}
          Settings
        </button>
        <Report>
          <button type="button">
            <AiOutlineFilePdf/>{' '}Download Report
          </button>
        </Report>
        <Save onClick={() => setOpen(false)}>
          <AiOutlineSave/> Save
        </Save>
      </MenuBar>

      { open && (
        <Settings>
          <div>
            <h2>Settings</h2>
            <label><strong style={{marginRight: 12}}>Edit Title</strong></label>
            <input
              name="title"
              value={state.title}
              onChange={e => dispatch({ 
                type: 'SET_TITLE',
                payload: e.target.value
              })}
              type="text"
            />
            <button
              onClick={handleSettingsToggle}
              type="button" 
            >Save</button>
          </div>
          <div>
            <h2>Information</h2>
            <h3>Creation Date</h3>
            <p>{WP_DATA.published}</p>
            { Object.keys(WP_DATA.revisions).length > 0 && (
              <>
                <h3>Revisions</h3>
                <ul>
                  {Object.values(WP_DATA.revisions).map(r => <li>{r.post_modified} - {r.post_author.data.display_name}</li>)}
                </ul>
              </>
            )}
          </div>
        </Settings>
      ) }
    </>
  )
}